module.exports = __webpack_public_path__ + "static/media/user_3.d6a7ede8.png";